import { z } from 'zod';
export const aiAgentConversationSortBySchema = z.enum([`last_activity_at`, `opened_at`, `created_at`, `status`]);
export const aiAgentConversationSortDirSchema = z.enum([`asc`, `desc`]);
export const aiAgentConversationsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
    sortBy: aiAgentConversationSortBySchema.optional(),
    sortDir: aiAgentConversationSortDirSchema.default(`desc`),
    statuses: z.union([
        z.string().trim().min(1),
        z.array(z.string().trim().min(1)),
    ]).transform(value => Array.isArray(value) ? value : [value]).optional(),
});
export const aiAgentConversationParamsSchema = z.object({
    conversationId: z.uuid(),
});
export const aiAgentCreateNoteBodySchema = z.object({
    content: z.string().trim().min(1).max(1500),
    mentionedUsers: z.array(z.uuid()).default([]).transform(mentionedUsers => Array.from(new Set(mentionedUsers))),
});
export const aiAgentSendMessageBodySchema = z.object({
    content: z.string().trim().min(1).max(1500),
});
export const aiAgentTaskDecisionParamsSchema = z.object({
    conversationId: z.uuid(),
    taskId: z.uuid(),
});
export const aiAgentTaskDecisionEditedArgsSchema = z.object({
    subject: z.string().optional(),
    body: z.string().optional(),
});
export const aiAgentTaskDecisionBodySchema = z.object({
    approved: z.boolean(),
    autoApproveTool: z.boolean().optional(),
    editedArgs: aiAgentTaskDecisionEditedArgsSchema.optional(),
});
export const aiAgentToolApprovalBodySchema = z.object({
    toolName: z.string().trim().min(1),
    autoApprove: z.boolean(),
});
export var AgentScopeField;
(function (AgentScopeField) {
    AgentScopeField["GROUP"] = "group";
    AgentScopeField["TAG"] = "tag";
})(AgentScopeField || (AgentScopeField = {}));
export var AgentScopeOperator;
(function (AgentScopeOperator) {
    AgentScopeOperator["IS"] = "is";
    AgentScopeOperator["IS_NOT"] = "is_not";
    AgentScopeOperator["INCLUDES"] = "includes";
    AgentScopeOperator["NOT_INCLUDES"] = "not_includes";
})(AgentScopeOperator || (AgentScopeOperator = {}));
export const AGENT_SCOPE_FIELD_OPERATORS = {
    [AgentScopeField.GROUP]: [AgentScopeOperator.IS, AgentScopeOperator.IS_NOT],
    [AgentScopeField.TAG]: [AgentScopeOperator.INCLUDES, AgentScopeOperator.NOT_INCLUDES],
};
export const agentScopeConditionSchema = z.object({
    field: z.enum(AgentScopeField),
    operator: z.enum(AgentScopeOperator),
    value: z.string().min(1),
}).superRefine((cond, ctx) => {
    if (!AGENT_SCOPE_FIELD_OPERATORS[cond.field].includes(cond.operator)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: `Operator ${cond.operator} is not valid for field ${cond.field}`, path: [`operator`] });
    }
});
export const agentScopeGroupSchema = z.object({
    conditions: z.array(agentScopeConditionSchema).min(1),
});
export const aiAgentSettingsSchema = z.object({
    enabled: z.boolean(),
    scopeRules: z.array(agentScopeGroupSchema),
});
export const updateAiAgentSettingsRequestSchema = aiAgentSettingsSchema.partial();
export const aiAgentPromptCreateBodySchema = z.object({
    title: z.string().trim().min(1),
    instruction: z.string().trim().min(1),
    enabled: z.boolean().optional(),
    position: z.coerce.number().int().min(0).optional(),
});
export const aiAgentPromptParamsSchema = z.object({
    id: z.uuid(),
});
export const aiAgentPromptUpdateBodySchema = z.object({
    title: z.string().trim().min(1).optional(),
    instruction: z.string().trim().min(1).optional(),
    enabled: z.boolean().optional(),
    position: z.coerce.number().int().min(0).optional(),
});
//# sourceMappingURL=aiAgent.js.map